import { render, staticRenderFns } from "./check-payment.vue?vue&type=template&id=1247029a&"
import script from "./check-payment.vue?vue&type=script&lang=js&"
export * from "./check-payment.vue?vue&type=script&lang=js&"
import style0 from "./check-payment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports